// @ts-nocheck
import { selector } from "recoil";
import { currentOrganisationDetails } from "./atom";

export const setCurrentOrganisationDetails = selector<any>({
  key: "setCurrentOrganisationDetails",
  get: () => null,
  set: ({ set }, currentCompany) => {
    set(currentOrganisationDetails, currentCompany);
  },
});

export const getCurrentOrganisationDetails = selector<any>({
  key: "getCurrentOrganisationDetails",
  get: ({ get }) => {
    return get(currentOrganisationDetails);
  },
});
